// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";


let firebaseConfig = {
  apiKey: "AIzaSyD6nwkAybjYj4QOnr92_6dk764Y_ImkmKk",
  authDomain: "elevated-baking-dashboard.firebaseapp.com",
  projectId: "elevated-baking-dashboard",
  storageBucket: "elevated-baking-dashboard.appspot.com",
  messagingSenderId: "443629498964",
  appId: "1:443629498964:web:5496d8af131398f921b3c1",
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getFirestore(app);
let firestore_emulator_host = process.env.REACT_APP_FIRESTORE_EMULATOR_HOST;
let firestore_emulator_port = process.env.REACT_APP_FIRESTORE_EMULATOR_PORT;
if (process.env.REACT_APP_PROCESSING_ENV === 'test') {
  connectFirestoreEmulator(database,firestore_emulator_host,firestore_emulator_port)
  //database.useEmulator('localhost',8156);
}
export default app;


